import QACommentEntity from "../../domain/entities/qa_comment.entity";
import { UserType } from "../../domain/entities/user.entity";
import { fakeUser } from "../repositories/auth/auth.repository.fake";

const fromJSON = (json: any): QACommentEntity => {
    const date = json.created_at.split("T")[0];
    return {
        comment: json.comment,
        id: json.id,
        date: new Date(date),
        user: {
            clientName: "",
            id: json.user_id,
            name: json.username,
            role: UserType.CLIENT,
            operationName: "",
            photo: "/assets/user-icon.png"
        }
    };
}

const QACommentDto = {
    fromJSON
}

export default QACommentDto;